// app/javascript/controllers/sortable_header_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["iconNone", "iconAsc", "iconDesc"]
  static values = {
    field: String,
    sort: { type: String, default: "" }
  }

  connect() {
    this.render()
  }

  toggleSort() {
    this.sortValue = { "": "asc", asc: "desc", desc: "" }[this.sortValue]
    this.render()
    this.navigate()
  }

  render() {
    this.iconNoneTarget.classList.toggle("hidden", this.sortValue !== "")
    this.iconAscTarget.classList.toggle("hidden", this.sortValue !== "asc")
    this.iconDescTarget.classList.toggle("hidden", this.sortValue !== "desc")
  }

  navigate() {
    const url = new URL(window.location)
    const key = `${this.fieldValue}_sort`
    this.sortValue ? url.searchParams.set(key, this.sortValue) : url.searchParams.delete(key)
    url.searchParams.delete("page")
    Turbo.visit(url, { frame: "members_list" })
  }
}